import { render, staticRenderFns } from "./ReportPurchasesPerSupplierPage.vue?vue&type=template&id=d2ba44ea&scoped=true"
import script from "./ReportPurchasesPerSupplierPage.vue?vue&type=script&lang=js"
export * from "./ReportPurchasesPerSupplierPage.vue?vue&type=script&lang=js"
import style0 from "./ReportPurchasesPerSupplierPage.vue?vue&type=style&index=0&id=d2ba44ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ba44ea",
  null
  
)

export default component.exports